import { Outlet } from "react-router-dom";
import styled from "styled-components";
import Header from "shared/components/Header";
import useHeader from "shared/hooks/useHeader";

const Teacher = () => {
    const {name} = useHeader();
    return(
        <Container>
            <Header name={name || ""} link="/teacher/home"/>
            <Main>
                <Outlet />
            </Main>
        </Container>
    )
}

    const Container = styled.div`
        display: flex;
        flex-direction: column;
        height: 100vh;
        min-height: 100vh;
        min-width: 100vw;
        overflow: hidden;
        background-color: #F8FAFC;
    `

    const Main = styled.main`
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        overflow: auto;
    `

export default Teacher;